import { Controller, useFormContext } from 'react-hook-form'
import { MultiSelect } from '@boltenergy-be/design-system'
import { useTranslation } from 'react-i18next'
import { useGetLanguage } from 'hooks/use-get-language'
import { ControlledMultiSelectProps } from './types.ts'
import { getFieldError, getFieldName } from 'components/form-fields/utils.ts'

const ControlledMultiSelect = ({ required, identifier, parentDotPath, ...props }: ControlledMultiSelectProps) => {
  // React Hook Form
  const { control } = useFormContext()

  // i18n
  const { t } = useTranslation('validation')
  const language = useGetLanguage()

  // Constants
  const fieldKey = getFieldName(identifier, parentDotPath)

  return (
    <Controller
      name={fieldKey}
      control={control}
      rules={{ required: t(($) => $.required) }}
      render={({ field, formState }) => (
        <MultiSelect
          {...props}
          {...{ language }}
          name={field.name}
          value={field.value}
          onChange={field.onChange}
          error={getFieldError(identifier, parentDotPath, formState.errors)?.message}
        />
      )}
    />
  )
}

export default ControlledMultiSelect
